"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OSCSettingsT = exports.OSCSettings = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * OSC Settings that are used in *any* osc application.
 */
class OSCSettings {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsOSCSettings(bb, obj) {
        return (obj || new OSCSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsOSCSettings(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new OSCSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    enabled() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    portIn() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    portOut() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    address(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startOSCSettings(builder) {
        builder.startObject(4);
    }
    static addEnabled(builder, enabled) {
        builder.addFieldInt8(0, +enabled, +false);
    }
    static addPortIn(builder, portIn) {
        builder.addFieldInt16(1, portIn, 0);
    }
    static addPortOut(builder, portOut) {
        builder.addFieldInt16(2, portOut, 0);
    }
    static addAddress(builder, addressOffset) {
        builder.addFieldOffset(3, addressOffset, 0);
    }
    static endOSCSettings(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createOSCSettings(builder, enabled, portIn, portOut, addressOffset) {
        OSCSettings.startOSCSettings(builder);
        OSCSettings.addEnabled(builder, enabled);
        OSCSettings.addPortIn(builder, portIn);
        OSCSettings.addPortOut(builder, portOut);
        OSCSettings.addAddress(builder, addressOffset);
        return OSCSettings.endOSCSettings(builder);
    }
    unpack() {
        return new OSCSettingsT(this.enabled(), this.portIn(), this.portOut(), this.address());
    }
    unpackTo(_o) {
        _o.enabled = this.enabled();
        _o.portIn = this.portIn();
        _o.portOut = this.portOut();
        _o.address = this.address();
    }
}
exports.OSCSettings = OSCSettings;
class OSCSettingsT {
    constructor(enabled = false, portIn = 0, portOut = 0, address = null) {
        this.enabled = enabled;
        this.portIn = portIn;
        this.portOut = portOut;
        this.address = address;
    }
    pack(builder) {
        const address = (this.address !== null ? builder.createString(this.address) : 0);
        return OSCSettings.createOSCSettings(builder, this.enabled, this.portIn, this.portOut, address);
    }
}
exports.OSCSettingsT = OSCSettingsT;
